import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AgencySettingsRoutes = defineRoute({
    home: {
        route: {
            path: "/agency-settings",
            component: () => loadView(import("./AgencySettingsHome.vue")),
        },
    },
});
